import { Component, OnInit } from '@angular/core';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { ViewsService } from 'src/app/services/views.service';

export class ViewByDay {
  Date: Date;
  count: number;
}

@Component({
  selector: 'app-views-daily-chart',
  templateUrl: './views-daily-chart.component.html',
  styleUrls: ['./views-daily-chart.component.scss']
})
export class ViewsDailyChartComponent implements OnInit {

  constructor(private viewsService : ViewsService, private clickstream : ClickStreamService) { }

  isLoading = true;
  selectedTimeFilter = 'WTD';
  timeFilters = ['WTD', 'MTD', 'YTD']
  chartData: ViewByDay[] = []

  ngOnInit(): void {
    this.filter(this.selectedTimeFilter);
  }
  
  filter(timeFilter : string) { 
    this.viewsService.getViewsByDayForUsersCharts(timeFilter).subscribe((res : ViewByDay[]) => {
      this.chartData = res;
      this.isLoading = false;
    });
    this.clickstream.send('views-daily-filter', 'click', 'Admin Dashboard', 'Chart Views Daily Filter', '', true);
  }

}
